import { useLanguage } from '@/contexts/LanguageContext';
import { demoAvatar } from '@/lib/demoAssets';
import { cn } from '@/lib/utils';

const EN_SRC = demoAvatar('En.png');
const FA_SRC = demoAvatar('Fa.png');

export function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();

  const renderFlag = (code: 'en' | 'fa', src: string, label: string) => {
    const active = language === code;
    return (
      <button
        type="button"
        onClick={() => setLanguage(code)}
        aria-label={t('header.switchTo', { name: label })}
        aria-pressed={active}
        className="flex h-11 w-11 flex-col items-center justify-center gap-0.5 rounded-md bg-transparent p-0 outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <img
          src={src}
          alt=""
          draggable={false}
          className={cn(
            'h-7 w-7 object-contain select-none sm:h-8 sm:w-8',
            active ? 'opacity-100' : 'opacity-45',
          )}
        />
        <span
          className={cn(
            'max-w-full truncate text-[9px] font-bold leading-none',
            active ? 'opacity-100' : 'opacity-50',
          )}
        >
          {label}
        </span>
      </button>
    );
  };

  return (
    <div className="flex h-11 items-center gap-0.5" dir="ltr">
      {renderFlag('en', EN_SRC, 'English')}
      {renderFlag('fa', FA_SRC, 'فارسی')}
    </div>
  );
}
